import { render, staticRenderFns } from "./GoodsLiveTips.vue?vue&type=template&id=6880ef48&scoped=true"
import script from "./GoodsLiveTips.vue?vue&type=script&lang=js"
export * from "./GoodsLiveTips.vue?vue&type=script&lang=js"
import style0 from "./GoodsLiveTips.vue?vue&type=style&index=0&id=6880ef48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6880ef48",
  null
  
)

export default component.exports